module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-down-9599be1e.svg";